import NormalFeed from '@/components/NormalFeed'
import { TFeedSubRequest } from '@/types'
import { useEffect, useState } from 'react'
import { ready, sync } from '@/services/outbox.service'
import { ResolvedSet } from '@nostr/gadgets/sets'

export default function FollowSetFeed({ followSet }: { followSet: ResolvedSet<string> }) {
  const [subRequests, setSubRequests] = useState<null | TFeedSubRequest[]>(null)

  useEffect(() => {
    const authors = followSet.items
    const abort = new AbortController()

    ready()
      .then(() =>
        sync(authors, window.hallway.universe.feedKinds, {
          signal: abort.signal
        })
      )
      .catch((err) => {
        console.warn(`bailing on follow-set sync: ${err}`)
      })

    setSubRequests([
      {
        source: 'local',
        filter: {
          authors
        }
      }
    ])

    return () => {
      abort.abort('<cancelled>')
    }
  }, [followSet])

  return <NormalFeed subRequests={subRequests} />
}
